
import { ReferentielApi } from '@/api/referentiel';
import { Horaire } from '@/model/horaire';
import { getISODay, parse, isWithinInterval } from 'date-fns';
import StoreBuilder from '../store-builder';

function getHorairesForToday (horaires: Horaire[]) {
  const indexJour = getISODay(Date.now());
  const horaire = horaires.filter(h => h.indexJour === indexJour)[0];

  if (horaire) {
    return {
      heureFermetureWeb: parse(horaire.heureFermetureWeb, 'kk:mm:ss', new Date()),
      heureOuvertureWeb: parse(horaire.heureOuvertureWeb, 'kk:mm:ss', new Date())
    };
  } else {
    // eslint-disable-next-line no-console
    console.error(new Error('Horaire introuvable pour le jour courant'));
    return {
      heureFermetureWeb: null,
      heureOuvertureWeb: null
    };
  }
}

const builder = new StoreBuilder('referentiel');
builder.addStatePart('horaires', [], () => ReferentielApi.getHoraires());
builder.addStatePart('informationsMarche', null, () => {
  return ReferentielApi.getInformationsMarche()
    .catch((error) => {
      if (error.response === undefined) {
        return null; // si 404 => pas d'erreur juste aucune info globale
      } if (error.response.status === 404) {
        return null; // si 404 => pas d'erreur juste aucune info globale
      } else {
        throw error;
      }
    });
}, 'NONE', 1800 /* 30m */);

builder.setGetters({
  horairesDuJour: (state: any) => {
    return getHorairesForToday(state.horaires);
  },
  isWebClosed: (state: any) => {
    const horaire = getHorairesForToday(state.horaires);
    return horaire.heureOuvertureWeb !== null && horaire.heureFermetureWeb !== null &&
      !isWithinInterval(Date.now(), { start: horaire.heureOuvertureWeb, end: horaire.heureFermetureWeb });
  }
});

builder.setActions({
  loadAll: ({ dispatch }: any) => {
    return Promise.all([
      dispatch('loadHoraires'),
      dispatch('loadInformationsMarche')
    ]).then(() => { });
  }
});

const module = builder.build();
export default module;
